<template>
  <ul
    v-if="showGroupTab"
    id="g-tabs"
    class="
      nav
      mobile-hide
      flex-row flex-md-column
      animate__animated animate__slideInLeft
    "
    :class="[animationClass]"
    :style="tabStyle"
  >
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{ rotate180: eng }"
        :to="routerHandler(1)"
        >{{ groupTitles[0] }}</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{ rotate180: eng }"
        :to="routerHandler(2)"
        >{{ groupTitles[1] }}</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        class="nav-link"
        :class="{ rotate180: eng }"
        :to="routerHandler(3)"
        >{{ groupTitles[2] }}</router-link
      >
    </li>
  </ul>
</template>

<script>
import 'animate.css';

export default {
  name: 'GroupTab',
  data() {
    return {
      isFixed: false,
      showGroupTab: true,
      animationClass: '',
      lastScrollPosition: 0,
      activeTitle: '數位動畫組',
      // groupTitles: ['數位動畫組', '視覺傳達設計組', '時尚設計組'],
      navHeight: 0,
      eng: false,
      // tabStyle: {
      //   height: `calc(100vh - ${document.getElementById('main-nav').offsetHeight}px + 25px)`,
      // },
    };
  },
  computed: {
    tabStyle() {
      return { height: `calc(100vh - ${this.navHeight}px + 25px)` };
    },
    groupTitles() {
      if (this.$route.name === 'AboutEn') {
        return ['Animation', 'Visaul Design', 'Fashion Design'];
      }
      return ['數位動畫組', '視覺傳達設計組', '時尚設計組'];
    },
  },
  methods: {
    routerHandler(n) {
      const rName = this.$route.name;
      return { name: rName, params: { groupId: `group${n}` } };
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const tabs = document.getElementById('g-tabs');
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition <= 0) {
        tabs.classList.add('mobile-hide');
        return;
      }

      if (currentScrollPosition < 0) {
        return;
      }

      if (currentScrollPosition > 0) {
        tabs.classList.remove('mobile-hide');
        return;
      }
      // this.showGroupTab = currentScrollPosition !== 0;
      // console.log(currentScrollPosition);
      // Here we determine whether we need to show or hide the navbar
      this.animationClass = currentScrollPosition < this.lastScrollPosition ? 'animate__slideInLeft' : 'animate__slideOutLeft';
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
    this.navHeight = document.getElementById('main-nav').offsetHeight;
  },
  beforeUnmount() {
    this.eng = false;
    window.removeEventListener('scroll', this.onScroll);
  },
  watch: {
    '$route.name': function (newValue) {
      if (newValue === 'AboutEn') {
        this.eng = true;
      } else {
        this.eng = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@media screen and (min-width: 768px)
  .rotate180
    transform: rotate(-180deg);

#g-tabs
  position: fixed;
  z-index: 999;
  left: 0;
  top: 153px;
  border-right: 1px solid $monoc4;
  background-color: $monoc1;
  z-index: 100;

// @media screen and (max-width: 767.5px)
// #g-tabs.mobile-hide
// top: -100vh;
// transition: all 0.3s linear;
li
  width: 66px;

.nav-link.router-link-active
  background-color: $monoc4;

  &, &:hover, &:focus, &:active
    color: $monoc1;

.nav-link
  padding: 18px 24px;
  margin: 0 auto;
  writing-mode: vertical-rl;
  font-size: 15px;
  letter-spacing: 3px;
  font-weight: 700;
  line-height: 18px;

  &, &:hover, &:focus, &:active
    color: $monoc4;

@media screen and (max-width: 1399.5px)
  #g-tabs
    top: 134px;

// @media screen and (max-width: 991.5px)
// #g-tabs
// top: 111px;
@media screen and (max-width: 767.5px)
  #g-tabs
    // top: 95px;
    position: initial !important;
    height: auto !important;
    border-right: none;
    border-bottom: 1px solid $monoc4;

  li
    width: calc((100vw / 3));
    flex: 1 1 0%;

  .nav-link
    padding: 18px 8px;
    text-align: center;
    margin: 0 auto;
    writing-mode: horizontal-tb;
    letter-spacing: 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    color: $monoc4;

// @media screen and (max-width: 574.5px)
// #g-tabs
// top: 90px;
// transition: all 0.3s linear;

// stop animation
@media only screen and (max-width: 767.5px)
  .animate__animated
    /* CSS transitions */
    -o-transition-property: none !important;
    -moz-transition-property: none !important;
    -ms-transition-property: none !important;
    -webkit-transition-property: none !important;
    transition-property: none !important;
    /* CSS transforms */
    -o-transform: none !important;
    -moz-transform: none !important;
    -ms-transform: none !important;
    -webkit-transform: none !important;
    transform: none !important;
    /* CSS animations */
    -webkit-animation: none !important;
    -moz-animation: none !important;
    -o-animation: none !important;
    -ms-animation: none !important;
    animation: none !important;
</style>
